import React, { useState, useEffect } from 'react';
import { useAuth } from '../../authentication/AuthContext';
import { getCounsellorTask, updateTaskStatus, getTaskSummaryCounsellorWise, getCounsellorDetails } from '../../services/getAdminApi';
import { UserCircle, Mail, Phone, Calendar, CheckCircle, Plus, ListTodo, Clock } from 'lucide-react';
import Swal from 'sweetalert2';

// Custom Card Component
const Card = ({ children, className }) => (
  <div className={`bg-white rounded-lg shadow-lg ${className}`}>
    {children}
  </div>
);

// Task creation modal component

// Statistics Card Component
const StatCard = ({ title, value, icon: Icon }) => (
  <Card className="p-6 transform transition-all duration-300 hover:-translate-y-1 hover:shadow-xl">
    <div className="flex items-center gap-4">
      <div className="p-3 bg-[#7494ec] bg-opacity-10 rounded-full">
        <Icon className="w-6 h-6 text-[#7494ec]" />
      </div>
      <div>
        <p className="text-sm text-gray-600">{title}</p>
        <p className="text-2xl font-bold text-[#7494ec]">{value}</p>
      </div>
    </div>
  </Card>
);

// Main CounsellorView Component
const CounsellorView = () => {
  const { user } = useAuth();
  const [localTasks, setLocalTasks] = useState([]);
  const [showModal, setShowModal] = useState(false);
   const [counsellorDetails, setcounsellorDetails] = useState({})
  const [taskStats, setTaskStats] = useState({
    total: 0,
    completed: 0,
    inProgress: 0,
    todo: 0,
  });

  useEffect(() => {
    //setLocalTasks(tasks);
    updateTaskStats();
    getTask(user.id)
    getCounsellorDetails(user.id).then((res)=>{
          setcounsellorDetails(res.data.data)
        })

  }, []);

  const updateTaskStats = () => {
    const res = getTaskSummaryCounsellorWise(user.id).then((res) => {
      if (res.status === 200) {
        const stats = {
          total: res.data.data.reduce((total, t) => total + t.count, 0),
          completed: res.data.data.filter(t => t.task_status.toLowerCase() === 'done').reduce((total, t) => total + t.count, 0),
          inProgress: res.data.data.filter(t => t.task_status.toLowerCase() === 'in progress').reduce((total, t) => total + t.count, 0),
          todo: res.data.data.filter(t => t.task_status.toLowerCase() === 'to do').reduce((total, t) => total + t.count, 0),
        };
        
        setTaskStats(stats);
      }
    })


  };

  const handleStatusChange = async (task_id, newStatus) => {
    try {
     // Optimistically update UI
      const updatedTasks = localTasks.map(task =>
        task.id === task_id ? { ...task, task_status: newStatus } : task
      );
      setLocalTasks(updatedTasks);
      updateTaskStats(); // Update stats immediately
   
      const res = await updateTaskStatus(task_id, { task_status: newStatus }).then((res)=>{
   
        if (res.status === 200) {
          Swal.fire('Success', 'Status updated successfully!', 'success');
        }
      })  
    } catch (error) {
      console.error("Error updating task status:", error);
      Swal.fire('Error', 'Failed to update status', 'error');
      // Revert changes on error
      getTask(user.id);
     updateTaskStats()
    }
  };

  const getTask = async (id) => {
    try {
      const res = await getCounsellorTask(id);
      setLocalTasks(res.data.data);
      updateTaskStats();
    } catch (error) {
      console.error("Error fetching tasks:", error);
      Swal.fire('Error', 'Failed to fetch tasks', 'error');
    }
  };

  const getStatusClasses = (status) => {
    const statusLower = status.toLowerCase();
    switch (statusLower) {
      case 'done':
        return 'bg-[#7494ec] text-white';
      case 'in progress':
        return 'bg-[#7494ec] bg-opacity-70 text-white';
      default:
        return 'bg-[#7494ec] bg-opacity-50 text-white';
    }
  };

  const getTaskBorderColor = (status) => {
    return 'border-l-[#7494ec]';
  };

  return (
    <div className="min-h-screen p-6">
      {/* Profile Card */}
      <Card className="mb-8 overflow-hidden">
        <div className="bg-[#7494ec] p-6">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="bg-white p-3 rounded-full">
                <UserCircle className="w-16 h-16 text-[#7494ec]" />
              </div>
              <div className="text-white">
                <h2 className="text-3xl font-bold">{counsellorDetails!= null ? counsellorDetails.name : "Counsellor Name"}</h2>
                <p className="text-blue-100">Senior Academic Counsellor</p>
              </div>
            </div>
            <div className="mt-4 md:mt-0 flex gap-6 text-white">
              <div className="flex items-center gap-2">
                <Mail className="w-5 h-5" />
                <span>{counsellorDetails!= null ? counsellorDetails.email : "counsellor@example.com"}</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-5 h-5" />
                <span>{counsellorDetails!= null ? counsellorDetails.phone : "+123456789"}</span>
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* Statistics Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mb-8">
        <StatCard title="Total Tasks" value={taskStats.total} icon={Calendar} />
        <StatCard title="Completed" value={taskStats.completed} icon={CheckCircle} />
        <StatCard title="In Progress" value={taskStats.inProgress} icon={Clock} />
        <StatCard title="To Do" value={taskStats.todo} icon={ListTodo} />
      </div>

      {/* Tasks Section */}
      <div className="mb-6">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-2xl font-bold text-[#7494ec] flex items-center gap-2">
            <Calendar className="w-6 h-6" />
            Task Management
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {localTasks.map((task, index) => (
            <div
              key={task.id}
              className={`bg-white rounded-lg shadow-lg overflow-hidden
                         border-l-4 ${getTaskBorderColor(task.task_status)}
                         transform transition-all duration-300
                         hover:-translate-y-1 hover:shadow-xl`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="p-5">
                <div className="flex justify-between items-start mb-4">
                  <h4 className="font-semibold text-lg text-gray-800">
                    {task.task_title}
                  </h4>
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusClasses(task.task_status)}`}>
                    {task.task_status}
                  </span>
                </div>

                <p className="text-gray-600 mb-4">
                  {task.task_description}
                </p>

                <div className="flex justify-between items-center">
                  <select
                    value={task.task_status}
                    onChange={(e) => handleStatusChange(task.id, e.target.value)}
                    className="px-3 py-2 rounded-lg bg-gray-50 border border-gray-200
                             text-sm transition-all duration-300
                             focus:ring-2 focus:ring-[#7494ec] focus:border-[#7494ec]
                             hover:border-[#7494ec]"
                  >
                    <option value="To do">To Do</option>
                    <option value="In progress">In Progress</option>
                    <option value="Done">Done</option>
                  </select>

                  {task.task_status.toLowerCase() === 'done' && (
                    <CheckCircle className="w-5 h-5 text-[#7494ec]" />
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

    
    </div>
  );
};

export default CounsellorView;